import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICardReformaPensiones } from '@constants/reforma-pensiones.constants';

@Component({
  selector: 'app-card-beneficios',
  templateUrl: './card-beneficios.component.html',
  styleUrl: './card-beneficios.component.scss',
  standalone: false
})
export class CardBeneficiosComponent {
  @Output() beneficioEmit = new EventEmitter<ICardReformaPensiones>();
  @Input() beneficio: ICardReformaPensiones;

  goToBeneficio() {
    this.beneficioEmit.emit(this.beneficio);
  }

  get isStatusClass(): boolean {
    return this.beneficio.statusClass !== 'sin-beneficios' && this.beneficio.enabledDetail === true;
  }

  convertirUrlsAEnlaces(texto: string): string {
    if (!texto) return texto;
    const urlRegex = /https?:\/\/[^\s]+/g;
    return texto.replaceAll(urlRegex, (url) => {
      const { cleanUrl, punctuation } = this.splitTrailingPunctuation(url);
      if (punctuation) {
        return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer">ChileAtiende</a>${punctuation}`;
      }
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">ChileAtiende</a>`;
    });
  }

  private splitTrailingPunctuation(url: string): { cleanUrl: string; punctuation: string } {
    const punctuationChars = new Set(['.', ',', ';', '!', '?', ')', '"', "'"]);
    let end = url.length;

    while (end > 0 && punctuationChars.has(url[end - 1])) {
      end--;
    }

    return {
      cleanUrl: url.slice(0, end),
      punctuation: url.slice(end),
    };
  }
}
